import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  color: var(--black);
  text-align: center;
  background-color: var(--white);
  height: 100%;
  width: 100%;

  .link-web {
    display: block;
    color: var(--black);


    u{
      font-weight: 600;
    }
    a {
      color: var(--black);
      margin-left: 8px;

      &:hover {
        color: var(--secondary);
      }
    }

    &.leave-of-study {
      u {
        color: #EA8B49;
      }

      a {
        &:hover {
          color: #EA8B49;
        }
      }
    }
  }

  .row-title {
    padding: 130px 150px 0 150px !important;
  }

  .row-section {
    padding: 0 158px 0 158px !important;
    margin-bottom: 5%;
  }

  @media only screen and (max-width: 540px) {
    .row-title {
      padding: 130px 52px 0 52px !important;
    }
    .row-section {
      padding: 0 52px 0 52px !important;

      .ant-col-6 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  }

  @media only screen and (max-width: 820px) {
    .row-title {
      padding: 130px 74px 0 74px;
    }
    .row-section {
      padding: 0 74px 0 74px;
    }
  }
`

export const Title = styled.h1`
  height: 100%;
  width: 100%;
  font-family: 'Noto Sans Thai';
  line-height: 150px;
  font-size: clamp(30px,9vw, 64px);
  text-align: left;

  @media only screen and (max-width: 414px) {
    line-height: 70px;
  }
`

export const TextSection = styled.p`
  color: var(--black);
  font-family: 'Noto Sans Thai';
  line-height: 35px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  margin-bottom: 20px;
  cursor: pointer;

  width: fit-content;
  position: relative;
  text-decoration: none;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 4px;
    background-color: var(--secondary);
    bottom: -1px;
    left: 0;
    transform-origin: right;
    transform: scaleX(0);
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before {
    transform-origin: left;
    transform: scaleX(1);
  }
`

export const ContainerCooper = styled.div`
  width: 100%;
  height: 100%;
  /* margin-top: 5%; */
  background-color: ${(props) => (props.bg ? props.bg : 'var(--white)')};
  padding: 130px 158px 130px 158px;

  @media only screen and (max-width: 540px) {
    padding: 40px 50px !important;

    .ant-col-15 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .ant-col-8 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .ant-col-offset-1 {
      margin-left: 0 !important;
    }
  }

  .col-leave {
    padding-left: 50px;
  }

  @media only screen and (max-width: 540px) {
    .col-leave {
      padding-left: 12px !important;
    }
  }

  @media only screen and (max-width: 1024px) {
    .ant-col-15 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .ant-col-8 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .ant-col-offset-1 {
      margin-left: 0 !important;
    }
  }
`

export const TextHead = styled.p`
  font-family: 'Noto Sans Thai';
  line-height: 60px;
  font-size: clamp(30px, 2.5vw, 40px);
  text-align: left;
  margin-bottom: 20px;

  @media only screen and (max-width: 1024px) {
    margin-top: 20px;
  }
`

export const Href = styled(Link)`
  color: var(--white);
  width: 100%;
  justify-content: center;
  display: flex;
`

export const CardImage = styled.div`
  width: 100%;
  padding: 5px;
  margin-bottom: 20px;

  img {
    width: 100%;
    height: 100%;
  }

  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;

  &:hover {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
`

export const ContainerCard = styled.div`
  width: 100%;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`

export const NumberList = styled.div`
  display: flex;
  width: 100%;
  font-family: 'Noto Sans Thai';
  line-height: 40px;
  font-size: clamp(20px, 2vw, 24px);
  text-align: left;
  margin-bottom: 20px;
  align-items: center;
  color: var(--black);

  span {
    color: var(--black);
  }

  @media only screen and (max-width: 414px) {
    display: block;

    span{
        margin-bottom: 16px !important;
    }
  }
`

export const Text = styled.p`
  color: var(--black);
  font-family: 'Noto Sans Thai';
  line-height: 35px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
`

export const TextNote = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  font-family: ${(props) => (props.font ? props.font : 'Noto Sans Thai')};
  line-height: 30px;
  font-size: 18px;
  text-align: left;
  margin-bottom: 20px;
`
